import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Button,
  CircularProgress
} from '@mui/material';
import { toast } from 'react-toastify';
import axios from 'axios';
import { API_ENDPOINTS } from '../../config/api';

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedUserData = localStorage.getItem('userData');
    const authToken = localStorage.getItem('authToken');
  
    // Eğer login olduysa, tekrar login sayfasına gelmesin
    if (storedUserData && authToken) {
      navigate('/dashboard', { replace: true });
    }
  }, []);
  const handleGoogleLogin = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_ENDPOINTS.auth.googleAuthUrl(), {
        withCredentials: true
      });
      const { authUrl } = response.data;
      window.location.href = authUrl;
    } catch (error) {
      console.error('Google auth URL alınırken hata:', error);
      toast.error('Google ile giriş başlatılamadı.');
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          minHeight: '60vh'
        }}
      >
        <Typography component="h1" variant="h5" gutterBottom>
          Giriş Yap
        </Typography>

        <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 3 }}>
          Google hesabınızla giriş yaparak anılarınızı paylaşmaya başlayın
        </Typography>

        <Box sx={{ mt: 2 }}>
          {loading ? (
            <CircularProgress />
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={handleGoogleLogin}
            >
              Google ile Giriş Yap
            </Button>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default Login;
